import React from 'react'
import LineClockIcon from 'LuxKit/Icons/line/LineClockIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

interface Props {
  className?: string
}

function OfferTimeLimitedText({ className }: Props) {
  return (
    <BodyTextBlock variant="medium" weight="bold" className={className} startIcon={<LineClockIcon className="highlight" />}>
      Time limited offer
    </BodyTextBlock>
  )
}

export default OfferTimeLimitedText
